import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaGraduationCap,
  FaFlask,
  FaHandshake,
  FaBolt,
  FaGlobe,
  FaBriefcase,
  FaHospital,
  FaLeaf,
  FaMicroscope,
  FaTint,
} from 'react-icons/fa';
import './Home.css';

/* Hero Orbit Animation */
function HeroOrbit() {
  return (
    <div className="hero__orbit-wrapper" aria-hidden="true">
      <div className="hero__orbit-core">⚛</div>

      <div className="hero__orbit-ring hero__orbit-ring--1">
        <div className="hero__orbit-dot" />
      </div>

      <div className="hero__orbit-ring hero__orbit-ring--2">
        <div className="hero__orbit-dot hero__orbit-dot--blue" />
      </div>

      <div className="hero__orbit-ring hero__orbit-ring--3">
        <div className="hero__orbit-dot hero__orbit-dot--white" />
      </div>
    </div>
  );
}

/* Mission Pillars */
const PILLARS = [
  {
    Icon:  FaGraduationCap,
    color: '#d34d21',
    title: 'Education & Training',
    text:  "Building Kenya's next generation of nuclear scientists, engineers, and policy experts.",
  },
  {
    Icon:  FaFlask,
    color: '#e24a87',
    title: 'Research & Innovation',
    text:  'Promoting peer-reviewed nuclear research and connecting Kenyan scientists globally.',
  },
  {
    Icon:  FaHandshake,
    color: '#23ebf5',
    title: 'Policy & Advocacy',
    text:  "Engaging government, IAEA, and NuPEA to shape Kenya's nuclear energy policy.",
  },
];

/* Mission Cards */
const MISSION_CARDS = [
  { Icon: FaBolt, color: '#C9A84C',     title: 'Clean Energy',    text: 'Nuclear power produces zero carbon emissions during operation.' },
  { Icon: FaGlobe, color: '#4A90E2',     title: 'Energy Security', text: "Reducing Kenya's reliance on imported fossil fuels." },
  { Icon: FaBriefcase, color: '#7ED321', title: 'Job Creation',    text: 'Thousands of skilled jobs across the nuclear value chain.' },
  { Icon: FaHospital,  color: '#F5A623',  title: 'Medical Uses',    text: 'Nuclear technology powers cancer treatment and diagnostics.' },
];

/* Why Nuclear Cards */
const WHY_CARDS = [
  {
    Icon:  FaLeaf,
    color: '#4CAF50',
    title: 'Low Carbon Emissions',
    text:  'Nuclear energy produces the least lifecycle carbon emissions of any energy source — even less than solar and wind.',
  },
  {
    Icon:  FaBolt,
    color: '#FFC107',
    title: 'Reliable Baseload Power',
    text:  'Unlike solar or wind, nuclear plants run 24/7 regardless of weather, providing stable electricity for homes and industry.',
  },
  {
    Icon:  FaGlobe,
    color: '#2196F3',
    title: "Kenya's Energy Future",
    text:  "Kenya's Vision 2030 and NuPEA's roadmap identify nuclear energy as essential for meeting growing electricity demand.",
  },
  {
    Icon:  FaMicroscope,
    color: '#9C27B0',
    title: 'Advanced Medicine',
    text:  'Nuclear technology enables cancer radiotherapy, medical imaging, and sterilisation of medical equipment across Kenya.',
  },
  {
    Icon:  FaTint,
    color: '#00BCD4',
    title: 'Water & Food Security',
    text:  'Nuclear techniques improve crop yields, detect soil degradation, and support clean water programmes across Africa.',
  },
  {
    Icon:  FaGraduationCap,
    color: '#FF5722',
    title: 'Skills & Innovation',
    text:  'A nuclear programme creates a pipeline of scientists, engineers, and technicians who drive innovation across all sectors.',
  },
];

/* News Articles (static) */
const NEWS = [
  
  {
    id: 1,
    tag:     'Education',
    date:    'May 2026',
    title:   'NSK Partners with Universities on Nuclear Engineering Curriculum',
    excerpt: 'The Nuclear Society of Kenya has signed MOUs with three Kenyan universities to develop accredited nuclear engineering modules.',
    slug:    '/blog',
  },
];

function Home() {
  return (
    <>
      {/* Hero */}
      <section className="hero" aria-labelledby="hero-heading">
        <div className="hero__bg-pattern" aria-hidden="true" />

        <div className="hero__inner">
          <div className="hero__content">
            <span className="hero__label">
              Nuclear Society of Kenya <br></br>
              Nguvu ya Sayansi ya Nyuklia Kenya
            </span>

            <h1 className="hero__title" id="hero-heading">
              Powering Kenya's Future with{' '}
              <span>Nuclear Science</span>
            </h1>

            <p className="hero__description">
              NSK brings together nuclear professionals, students, and
              policymakers to advance peaceful nuclear technology for
              Kenya's sustainable energy future.
            </p>

            <div className="hero__actions">
              <Link to="/join" className="btn btn--primary">
                Join NSK Today
              </Link>
              <Link to="/about" className="btn btn--outline">
                Learn More
              </Link>
            </div>
        
             
           
            </div>
          

          <div className="hero__visual">
            <HeroOrbit />
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="mission" aria-labelledby="mission-heading">
        <div className="mission__inner">
          <div className="mission__content">
            <p className="section__label">Our Mission</p>
            <h2 className="section__title" id="mission-heading">
              Advancing Nuclear Science for Kenya
            </h2>
            <p className="mission__body">
              The Nuclear Society of Kenya (NSK) is a professional body
              dedicated to promoting the development and application of
              nuclear science and technology for the benefit of Kenyans.
              We work in alignment with IAEA standards and Kenya's
              national energy strategy.
            </p>

            <div className="mission__pillars">
              {PILLARS.map(({ Icon, title, text, color }) => (
                <div className="mission__pillar" key={title}>
                    <div className="mission__pillar-icon" aria-hidden="true">
                      <Icon
                        size={24}
                        style={{ color }}
                      />
                    </div>

                    <div>
                      <div className="mission__pillar-title">{title}</div>
                      <div className="mission__pillar-text">{text}</div>
                    </div>
                </div>
             ))}
            </div>

            <Link to="/about" className="btn btn--green" style={{ marginTop: '1rem', alignSelf: 'flex-start' }}>
              About NSK
            </Link>
          </div>

          <div className="mission__cards" aria-label="Nuclear benefits">
            {MISSION_CARDS.map(({ Icon, title, text, color }) => (
              <article className="mission__card" key={title}>
                <div className="mission__card-icon" aria-hidden="true">
                  <Icon color={color} />
                </div>
                <h3 className="mission__card-title">{title}</h3>
                <p className="mission__card-text">{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Why Nuclear */}
      <section className="why-nuclear" aria-labelledby="why-heading">
        <div className="why-nuclear__inner">
          <div className="why-nuclear__header">
            <p className="section__label">Why It Matters</p>
            <h2 className="section__title why-nuclear__title" id="why-heading">
              Why Nuclear Energy for Kenya?
            </h2>
            <p className="section__subtitle why-nuclear__subtitle">
              Nuclear technology offers unique solutions to Kenya's most
              pressing challenges — from clean energy to food security.
            </p>
          </div>

          <div className="why-nuclear__grid">
            {WHY_CARDS.map(({ Icon, title, text, color }) => (
              <article className="why-nuclear__card" key={title}>
                <div className="why-nuclear__card-icon" aria-hidden="true">
                   <Icon
                      size={42}
                      style={{ color }}
                   />
                </div>

                <h3 className="why-nuclear__card-title">{title}</h3>
                <p className="why-nuclear__card-text">{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Latest News */}
      <section className="news" aria-labelledby="news-heading">
        <div className="news__inner">
          <div className="news__header">
            <div>
              <p className="section__label">Latest Updates</p>
              <h2 className="section__title" id="news-heading">
                News & Events
              </h2>
            </div>
            <Link to="/blog" className="btn btn--green">
              View All Posts
            </Link>
          </div>

          <div className="news__grid">
            {NEWS.map(({ id, tag, date, title, excerpt, slug }) => (
              <article className="news__card" key={id}>
                <div className="news__card-body">
                  <span className="news__card-tag">{tag}</span>
                  <time className="news__card-date">{date}</time>
                  <h3 className="news__card-title">{title}</h3>
                  <p className="news__card-excerpt">{excerpt}</p>
                  <Link to={slug} className="news__card-link">
                    Read more →
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="cta-banner" aria-labelledby="cta-heading">
        <div className="cta-banner__inner">
          <h2 className="cta-banner__title" id="cta-heading">
            Ready to Shape Kenya's{' '}
            <span>Nuclear Future?</span>
          </h2>
          <p className="cta-banner__text">
            Join a growing community of nuclear professionals, researchers,
            and students committed to Kenya's energy independence and
            scientific advancement.
          </p>
          <div className="cta-banner__actions">
            <Link to="/join" className="btn btn--primary">
              Become a Member
            </Link>
            <Link to="/contact" className="btn btn--outline">
              Get in Touch
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;